<template>
  <div>
    <vs-tabs alignment="fixed">
      <vs-tab :label="'Functionnality'">
        <div>
          <h4 class="mb-4">Setting</h4>
          <vs-input
            :danger="errors.name"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Kiosk.AddKioskPrompt.Name'),
              })
            "
            :label="$t('Kiosk.AddKioskPrompt.Name')"
            v-model="promptData.name"
            class="w-100 mb-2"
          />
          <vs-select
            :danger="errors.queues"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Kiosk.AddKioskPrompt.Queues'),
              })
            "
            :placeholder="$t('Kiosk.AddKioskPrompt.Queues')"
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.Queues')"
            autocomplete
            multiple
            v-model="promptData.queues"
          >
            <vs-select-item
              :key="index"
              :value="queue.id"
              :text="queue.title"
              v-for="(queue, index) in queues"
            />
          </vs-select>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.Status')"
            v-model="promptData.status"
          >
            <vs-select-item
              :value="0"
              :text="$t('Kiosk.AddKioskPrompt.StatusInactive')"
            />
            <vs-select-item
              :value="1"
              :text="$t('Kiosk.AddKioskPrompt.StatusActive')"
            />
          </vs-select>

          <h4 class="mb-4 mt-4">Functionalities</h4>
          <vs-row>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.printTicket"
                checked
              >
                {{ $t("Kiosk.AddKioskPrompt.PrintTicket") }}
              </vs-checkbox>

              <div
                class="ticket-sty"
                v-if="promptData.printTicket"
                style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
              >
                <input
                  type="radio"
                  id="one"
                  :value="'Long'"
                  v-model="promptData.ticket_style"
                />
                <label for="one" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.LongTicket") }}
                </label>
                <br />
                <input
                  type="radio"
                  id="two"
                  :value="'Short'"
                  v-model="promptData.ticket_style"
                />
                <label for="two" style="margin-left: 10px">
                  {{ $t("Kiosk.AddKioskPrompt.ShortTicket") }}
                </label>
              </div>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.smsTicket"
                checked
              >
                {{ $t("Kiosk.AddKioskPrompt.SMSTicket") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowBooking"
              >
                {{ $t("Kiosk.AddKioskPrompt.AllowBooking") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowQueue"
              >
                {{ $t("New.allowQueue") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowMultipleServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowMultipleServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowQuantityServices"
              >
                {{ $t("Kiosk.AddKioskPrompt.allowQuantityServices") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.collectDetails"
              >
                {{ $t("Kiosk.AddKioskPrompt.CollectCustomerDetails") }}
              </vs-checkbox>
            </vs-col>
            <vs-col vs-w="6">
              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.require_internal_id"
              >
                {{ $t("Kiosk.AddKioskPrompt.RequireInternalId") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.should_print"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShouldPrint") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.show_keyboard"
              >
                {{ $t("Kiosk.AddKioskPrompt.ShowKeyboard") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.loginRequired"
              >
                {{ $t("Kiosk.AddKioskPrompt.GuestLogin") }}
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.multi_language"
              >
                Multi languages
              </vs-checkbox>

              <vs-checkbox
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.allowTxtQte"
              >
                {{ "Modify quantity services text" }}
              </vs-checkbox>

              <div v-if="promptData.allowTxtQte">
                <vs-textarea
                  :label="'Services quantity text'"
                  rows="5"
                  v-model="promptData.quantityText"
                  class="w-100 mb-2"
                />
              </div>
            </vs-col>
          </vs-row>

          <div
            class="ticket-sty mt-3"
            style="
                        border: 1px solid #888;
                        padding: 10px;
                        border-radius: 5px;
                      "
          >
            <b>Language par defaut: </b><br />
            <input
              type="radio"
              id="onee"
              :value="'fr'"
              v-model="promptData.default_language"
            />
            <label for="onee" style="margin-left: 10px">
              Francais
            </label>
            <br />
            <input
              type="radio"
              id="twoo"
              :value="'en'"
              v-model="promptData.default_language"
            />
            <label for="twoo" style="margin-left: 10px">
              Anglais
            </label>
            <br />
            <input
              type="radio"
              id="threee"
              :value="'ar'"
              v-model="promptData.default_language"
            />
            <label for="threee" style="margin-left: 10px">
              Arabe
            </label>
          </div>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.GuestPseudo')"
            v-model="promptData.pseudo"
            v-if="promptData.loginRequired == 0"
          >
            <vs-select-item :value="1" :text="$t('Kiosk.Pseudos.Customer')" />
            <vs-select-item :value="2" :text="$t('Kiosk.Pseudos.Patient')" />
            <vs-select-item :value="3" :text="$t('Kiosk.Pseudos.User')" />
          </vs-select>

          <vs-row>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.IpAddress')"
                v-model="promptData.ip_address"
                class="w-100 mb-2"
              />
            </vs-col>
            <vs-col vs-w="6">
              <vs-input
                :label="$t('Kiosk.AddKioskPrompt.MacAddress')"
                v-model="promptData.mac_address"
                class="w-100 mb-2"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>

      <vs-tab :label="'Appearance'">
        <div>
          <vs-row class="mb-2 mt-2">
            <vs-col vs-w="6">
              <vs-select
                style="width: 100%"
                class="mb-2 mt-2"
                :label="$t('Kiosk.AddKioskPrompt.Theme')"
                v-model="promptData.theme"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in themes"
                />
              </vs-select>
            </vs-col>

            <vs-col vs-w="5">
              <label class="vs-select--label mt-2">{{
                $t("Kiosk.AddKioskPrompt.Zoom")
              }}</label>
              <br />
              <vs-input-number
                style="margin: 0px 15px"
                size="large"
                :max="100"
                :min="20"
                v-model="promptData.zoom"
              />
            </vs-col>
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label w-50 mb-2 mt-2"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryDark") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultPrimary">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultPrimary"
              v-model="promptData.primary"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2 w-50"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryMedium") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultSecondary">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultSecondary"
              v-model="promptData.secondary"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label mt-2 mb-2 w-50"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.PrimaryLight") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultSuccess">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultSuccess"
              v-model="promptData.success"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label class="vs-input--label mt-2 w-50" for="color-add-edit">{{
              $t("Kiosk.AddKioskPrompt.Colors.Secondary")
            }}</label>
            <vs-checkbox class="w-25 mt-2" v-model="defaultDanger">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultDanger"
              v-model="promptData.danger"
              type="color"
              name=""
              value=""
              class="w-15 mt-2"
            />
          </vs-row>

          <vs-row class="ml-2">
            <label
              class="vs-input--label w-50 mb-2 mt-2"
              for="color-add-edit"
              >{{ $t("Kiosk.AddKioskPrompt.Colors.Info") }}</label
            >
            <vs-checkbox class="w-25 mb-2 mt-2" v-model="defaultInfo">{{
              $t("Kiosk.AddKioskPrompt.Colors.Default")
            }}</vs-checkbox>
            <input
              v-if="!defaultInfo"
              v-model="promptData.info"
              type="color"
              name=""
              value=""
              class="w-15 mb-2 mt-2"
            />
          </vs-row>

          <vs-input
            type="file"
            class="w-100 mb-2 mt-2"
            id="fileInput"
            :label="$t('Kiosk.AddKioskPrompt.Photo')"
            v-model="promptData.photo"
          />
          <vs-input
            :label="$t('Kiosk.AddKioskPrompt.imagePath')"
            v-model="promptData.imagePath"
            class="w-100 mb-2 mt-3"
          />
        </div>
      </vs-tab>
    </vs-tabs>
    <vs-row class="ml-1 mt-3">
      <vs-col vs-w="4">
        <vs-button color="primary" @click="addKiosk()" class="w-100 mb-2">{{
          $t("Kiosk.AddKioskPrompt.SubmitButton")
        }}</vs-button>
      </vs-col>
    </vs-row>
    <!---Show Sectet --->
    <vs-prompt
      color="success"
      :active.sync="createShowSecret"
      :title="$t('Kiosk.ShowSecretPrompt.Title')"
      :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
      buttonAccept="false"
    >
      <div>
        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Key") }}
          </h4>
          <h3 class="mt-2">{{ createKeyValue }}</h3>
        </div>

        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Secret") }}
          </h4>
          <h3 class="mt-2 mb-2">{{ createSecretValue }}</h3>
          <span class="text-danger mt-2">{{
            $t("Kiosk.ShowSecretPrompt.SecretSave")
          }}</span>
        </div>

        <div class="mb-4">
          <h4 class="font-weight-light">
            {{ $t("Kiosk.ShowSecretPrompt.Token") }}
          </h4>
          <vs-input v-model="createTokenValue" disabled class="w-100" />
          <span class="text-danger mt-2">{{
            $t("Kiosk.ShowSecretPrompt.TokenSave")
          }}</span>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { kioskService, queueService } from "../../_services";
import router from "../../_helpers/router";
// moment

export default {
  name: "CreateKiosk",
  data: () => ({
    title: "CreateKiosk",
    createShowSecret: false,
    createSecretValue: "",
    createKeyValue: "",
    createTokenValue: "",
    promptData: {
      multi_language: true,
      default_language: "fr",
      name: "",
      photo: "",
      theme: "liberrex",
      status: 1,
      printTicket: 1,
      smsTicket: "Long",
      ticket_style: "1",
      allowBooking: 0,
      allowQueue: 1,
      allowMultipleServices: 1,
      allowQuantityServices: 0,
      allowTxtQte: 0,
      quantityText: `{"en": "", "fr": "", "ar": ""}`,
      imagePath: "",
      collectDetails: 0,
      queues: [],
      ip_address: "",
      mac_address: "",
      require_internal_id: 0,
      should_print: 0,
      show_keyboard: 0,
      loginRequired: 0,
      pseudo: 0,
      primary: "",
      secondary: "",
      success: "",
      danger: "",
      zoom: 100,
      info: "",
    },
    defaultInfo: true,
    errors: {
      name: false,
      queues: false,
    },
    defaultPrimary: true,
    defaultSecondary: true,
    defaultSuccess: true,
    defaultDanger: true,
    defaultEditPrimary: false,
    defaultEditSecondary: false,
    defaultEditSuccess: false,
    defaultEditDanger: false,
  }),
  props: {
    queues: Array,
    themes: Array,
  },
  methods: {
    getAllKiosk() {
      this.$emit("refresh_kiosk", "refresh_kiosk");
    },
    sendKeySecret(key, secret, authToken) {
      this.$emit("credentials", {
        key: key,
        secret: secret,
        authToken: authToken,
      });
    },
    addKiosk() {
      let res = this.validateFields();
      if (!res) {
        return false;
      }
      this.showLoading();

      let kioskData = new FormData();
      kioskData.append("name", this.promptData.name);
      kioskData.append("queues", this.promptData.queues.join(","));
      kioskData.append("theme", this.promptData.theme);
      kioskData.append("status", this.promptData.status);
      kioskData.append("ip_address", this.promptData.ip_address);
      kioskData.append("mac_address", this.promptData.mac_address);
      kioskData.append("allow_booking", this.promptData.allowBooking ? 1 : 0);
      kioskData.append("allow_queue", this.promptData.allowQueue ? 1 : 0);
      kioskData.append(
        "allow_multiple_services",
        this.promptData.allowMultipleServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_services",
        this.promptData.allowQuantityServices ? 1 : 0
      );
      kioskData.append(
        "allow_quantity_text",
        this.promptData.allowTxtQte ? 1 : 0
      );
      kioskData.append("quantity_text", this.promptData.quantityText);
      kioskData.append("image_path", this.promptData.imagePath);
      kioskData.append("print_ticket", this.promptData.printTicket ? 1 : 0);
      kioskData.append("sms_ticket", this.promptData.smsTicket ? 1 : 0);
      kioskData.append("ticket_style", this.promptData.ticket_style);
      kioskData.append(
        "collect_details",
        this.promptData.collectDetails ? 1 : 0
      );
      kioskData.append(
        "require_internal_id",
        this.promptData.require_internal_id ? 1 : 0
      );
      kioskData.append("should_print", this.promptData.should_print ? 1 : 0);
      kioskData.append("show_keyboard", this.promptData.show_keyboard ? 1 : 0);
      kioskData.append("login_required", this.promptData.loginRequired ? 1 : 0);
      kioskData.append("pseudo", this.promptData.pseudo);
      kioskData.append("zoom", this.promptData.zoom);
      kioskData.append("multi_language", this.promptData.multi_language);
      kioskData.append("default_language", this.promptData.default_language);

      if (!this.defaultPrimary) {
        kioskData.append("primary", this.promptData.primary);
      } else if (this.defaultPrimary) {
        kioskData.append("primary", "");
      }
      if (!this.defaultSecondary) {
        kioskData.append("secondary", this.promptData.secondary);
      } else if (this.defaultSecondary) {
        kioskData.append("secondary", "");
      }
      if (!this.defaultSuccess) {
        kioskData.append("success", this.promptData.success);
      } else if (this.defaultSuccess) {
        kioskData.append("success", "");
      }
      if (!this.defaultDanger) {
        kioskData.append("danger", this.promptData.danger);
      } else if (this.defaultDanger) {
        kioskData.append("danger", "");
      }
      if (!this.defaultInfo) {
        kioskData.append("info", this.promptData.info);
      } else if (this.defaultInfo) {
        kioskData.append("info", "");
      }

      if (
        document.getElementById("fileInput") &&
        document.getElementById("fileInput").files[0]
      ) {
        kioskData.append(
          "photo",
          document.getElementById("fileInput").files[0]
        );
      }
      kioskData.append("_method", "PUT");

      kioskService
        .create(kioskData)
        .then(
          function(data) {
            this.getAllKiosk();
            this.sendKeySecret(data.key, data.secret, data.auto_auth_token);
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Kiosk.AddKioskPrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Kiosk.AddKioskPrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.close();
            this.hideLoading();
          }.bind(this)
        );
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateFields() {
      this.errors.name = this.promptData.name ? false : true;
      this.errors.queues = this.promptData.queues.length > 0 ? false : true;

      let { name, queues } = this.errors;
      return !(name || queues);
    },
    close() {
      this.$emit("hide", "close");
    },
    showLoading() {
      this.$vs.loading({
        container: "#kiosks-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#kiosks-box > .con-vs-loading");
    },
  },
};
</script>
